/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
export default {
  signoutConfirmMessage: 'Are you sure you want to logout?',
  deleteAccountConfirmMessage: 'Are you sure you want to delete your account?',
  deleteAccountConfirmedFeedback: 'Request received. We will process your request within 24 hours and email you a confirmation.',
  customAttribute: {
    eulaVersionAgreed: 'custom:eulaVersionAgreed',
    t1: 'custom:t1',
    t2: 'custom:t2',
    t3: 'custom:t3',
    t4: 'custom:t4',
    fs: 'custom:fs',
    versionUsage: 'custom:versionUsage',
    channel: 'custom:channel',
    trialYN: 'custom:trialYN',
    appVersionUsed: 'custom:appVersionUsed',
    appinstalldate: 'custom:appinstalldate',
    rCode: 'custom:rCode',
    eulaVersionAgreedOn: 'custom:eulaVersionAgreedOn',
    lastLoginOn: 'custom:lastLoginOn',
    appFlowVersionUsed: 'custom:appFlowVersionUsed',
  },
  accountExpiry: {
    orange: 7,
    red: 0,
  },
  allRequiredField: 'Please complete all fields.',
  registerPasswordNotMatch: 'Password and Confirm field do not match.',
  emailAndPasswordRequired: 'Email and Password are required.',
  emailValidRequired: 'Please enter valid email.',
  defautPasscode: 'ninja@123',
  passwordNotMatch: 'New Password and Confirm Password do not match.',
  passwordMinLengthRequired: 'Password must be atleast 6 characters.',
  refreshTokenDuration: 900000, // 15 minutes
  ftDu: 20160, // Free trial duration 14 Days = 20160 minutes
  ftDuExtra: 10080, // Free trial duration if coupon is applied//this is not used now
  durationOfPwdChangeSuccess: 2000,
  processingText: {
    connectingItunes: 'Connecting to iTunes ...',
    authenticating: 'Authenticating ...',
    loadingPref: 'Loading preferences ...',
    signup: 'Registering ...',
    login: 'Logging in ...',
    initializing: 'Initializing ...',
    pleaseWait: 'Please wait ...',
    verificationCodeSent: 'Verfication code sent to your email address.',
    passwordChanged: 'Password changed successfully',
  },
  allowedStorageKeys: [
    'bn_lastViewedStateKey',
    'bn_applicationSetting',
    'bn_deviceSpecificSetting',
    'bn_routeprofileSetting',
    'bn_meteogramSetting',
    'bn_weatherSetting',
    'bn_imagerySetting',
    'bn_airportsHistory',
    'bn_serviceHost',
    'bn_favoriteMarkedViews',
    'bn_suppressedMets',
    'bn_avwxUserOld',
    'bn_forgotPwdState',
    'bn_unregisteredUser',
    'bn_lastOtuOn',
    'bn_lastVersionCheckedForUpdate',
    'bn_lastMessageOfDaySeen',
    'bn_avwxUser',
    'bn_sevenDayWeatherApiUrlsMapping',
    'bn_preBootstrapLastOtuOn',
    'bn_lastEdt',
    'bn_tu',
    'bn_sa',
    'bn_smea',
    '_secure__ls__metadata',
    'bn_uc',
  ],
  signoutExcludedKeys: [
    'bn_deviceSpecificSetting',
    'bn_unregisteredUser',
    'bn_forgotPwdState',
    'bn_serviceHost',
    'bn_lastVersionCheckedForUpdate',
    'bn_lastMessageOfDaySeen',
    'bn_avwxUser',
    'bn_avwxUserOld',
    'bn_sevenDayWeatherApiUrlsMapping',
    'bn_preBootstrapLastOtuOn',
    'bn_tu',
    'bn_paypalPlans',
    'bn_sa',
    '_secure__ls__metadata',
    'supabase_auth',
    'bn_uc',
    'bn_smea',
    'bn_firstSoftAskGeolocationAccess',
    'bn_geoLocationPermissionGiven',
  ],
};
